import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dragon-boat-draw/artifacts/arpymfsi_Gemini_Generated_Image_ebdk68ebdk68ebdk.png";

export const GOLD_ZONGZI_URL =
  "https://customer-assets.emergentagent.com/job_dragon-boat-draw/artifacts/ht9fqkxb_Gemini_Generated_Image_e542f4e542f4e542.png";

export const DRAGON_BOAT_URL =
  "https://customer-assets.emergentagent.com/job_dragon-boat-draw/artifacts/vipp9pr6_%E6%8A%A0%E5%9B%BE%20%287%29.png";

export function shortAddr(a) {
  if (!a) return "";
  return `${a.slice(0, 6)}…${a.slice(-4)}`;
}

export function fmtBnb(wei, digits = 4) {
  if (wei == null) return "0";
  const n = Number(wei) / 1e18;
  if (n === 0) return "0";
  if (n < 0.0001) return n.toExponential(2);
  return n.toFixed(digits).replace(/0+$/, "").replace(/\.$/, "");
}

export function fmtToken(wei, decimals = 18, digits = 0) {
  if (wei == null) return "0";
  // 使用 BigInt 除法避免大数精度丢失
  try {
    const bw = typeof wei === "bigint" ? wei : BigInt(wei);
    const base = 10n ** BigInt(decimals);
    const whole = bw / base;
    if (digits === 0) return Number(whole).toLocaleString();
    const frac = bw % base;
    const fracStr = (Number(frac) / Number(base)).toFixed(digits).slice(1);
    return Number(whole).toLocaleString() + fracStr;
  } catch {
    const n = Number(wei) / 10 ** decimals;
    if (digits === 0) return Math.floor(n).toLocaleString();
    return n.toFixed(digits);
  }
}

export function fmtSecs(s) {
  if (s == null || s <= 0) return "00:00";
  const m = Math.floor(s / 60);
  const ss = s % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    return `${h}h ${m % 60}m`;
  }
  return `${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export const TIER_LABEL = {
  0: { name: "谢谢参与", emoji: "🥟", sub: "画饼充饥" },
  1: { name: "幸运粽子", emoji: "🍀", sub: "一等奖" },
  2: { name: "安康金粽", emoji: "🟡", sub: "二等奖" },
  3: { name: "吉祥艾草", emoji: "🍃", sub: "三等奖" },
};

// 龙舟 SVG（装饰用）
export const DragonBoat = ({ className = "" }) => (
  <svg viewBox="0 0 480 140" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hull" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#0D5C3A" />
        <stop offset="100%" stopColor="#062b1c" />
      </linearGradient>
      <linearGradient id="head" x1="0" x2="1">
        <stop offset="0%" stopColor="#16A065" />
        <stop offset="100%" stopColor="#F3BA2F" />
      </linearGradient>
    </defs>
    {/* 龙头 */}
    <path d="M40 80 q-22 -6 -28 -28 q24 6 38 6 q4 -14 22 -18 q-6 14 6 22 q14 0 36 -8 q-8 22 -32 30 z" fill="url(#head)" stroke="#F3BA2F" strokeWidth="1.5" />
    <circle cx="32" cy="62" r="3" fill="#0A2540" />
    {/* 船身 */}
    <path d="M50 86 q120 -38 320 -10 q70 8 90 18 q-30 30 -90 32 q-180 6 -300 -14 q-22 -8 -20 -26 z" fill="url(#hull)" stroke="#F3BA2F" strokeWidth="1.5" />
    {/* 龙尾 */}
    <path d="M440 92 q26 -22 36 -8 q-4 18 -16 28 q-14 -6 -24 -12 z" fill="url(#head)" stroke="#F3BA2F" strokeWidth="1.5" />
    {/* 桨 */}
    {Array.from({ length: 6 }).map((_, i) => {
      const x = 90 + i * 50;
      return (
        <g key={i}>
          <line x1={x} y1={70} x2={x + 6} y2={42} stroke="#F3BA2F" strokeWidth="2" />
          <ellipse cx={x + 8} cy={38} rx="6" ry="3" fill="#F3BA2F" />
        </g>
      );
    })}
    {/* 水波 */}
    <path d="M0 124 q40 -10 80 0 t80 0 t80 0 t80 0 t80 0 t80 0" fill="none" stroke="rgba(22,160,101,0.5)" strokeWidth="2" />
    <path d="M0 134 q40 -8 80 0 t80 0 t80 0 t80 0 t80 0 t80 0" fill="none" stroke="rgba(22,160,101,0.3)" strokeWidth="2" />
  </svg>
);

// 沙漏
export const Hourglass = ({ className = "", running = false }) => (
  <svg viewBox="0 0 80 80" className={className}>
    <defs>
      <linearGradient id="hg" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#F3BA2F" />
        <stop offset="100%" stopColor="#16A065" />
      </linearGradient>
    </defs>
    <g className={running ? "spin-slow" : ""} style={{ transformOrigin: "40px 40px" }}>
      <path d="M15 10 h50 v10 l-22 18 q-3 2 0 4 l22 18 v10 h-50 v-10 l22 -18 q3 -2 0 -4 l-22 -18 z"
            fill="none" stroke="url(#hg)" strokeWidth="2.5" />
      <path d="M22 14 h36 l-18 14 z" fill="rgba(243, 186, 47, 0.45)" />
      <path d="M22 66 h36 l-18 -14 z" fill="rgba(22, 160, 101, 0.45)" />
    </g>
  </svg>
);

// 粽叶云纹装饰
export const CloudPattern = ({ className = "" }) => (
  <svg viewBox="0 0 200 60" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M10 30 q10 -20 30 -10 q15 -15 30 0 q15 -10 25 5 q15 -10 30 0 q10 -15 30 -5 q10 8 25 5"
      fill="none" stroke="rgba(243, 186, 47, 0.45)" strokeWidth="1.2" />
  </svg>
);
